export default "__VITE_ASSET__uP6rmF6$__"